import { Component } from '@angular/core';

@Component({
  selector: 'app-make-listproduct',
  standalone: true,
  imports: [],
  templateUrl: './make-listproduct.component.html',
  styleUrl: './make-listproduct.component.css'
})
export class MakeListproductComponent {

}
